<template>
  <SelectTableDialog
    title="关联结算批次"
    ref="selectTableDialog"
    :searchColumns="searchColumns"
    :columnList="columnList"
    :defaultVisible="defaultVisible"
    :API="API"
    :extraData="extraData"
    :getDataKey="'records'"
    :confirmUnchecked="false"
    :isMultiple="false"
    width="1200px"
    @close="close"
    @confirm="confirm"
  >
  </SelectTableDialog>
</template>

<script>
  import SelectTableDialog from '@/components/SelectTableDialog';
  import API from '@/api/capitalCenter/settle';
  // import DataBaseAPI from '@/api/dataBase';
  export default {
    props: {
      confirmApi: {
        // 弹窗标题
        type: String,
        default: () => '',
      },
    },
    components: {
      SelectTableDialog,
    },
    data() {
      return {
        defaultVisible: false,
        API: API.LIST_ORDER_SETTLE_BY_PAGE,
        extraData: {},
      };
    },
    computed: {
      searchColumns() {
        return [
          {
            prop: 'settleNo',
            name: this.$t('batchList.column.settleNo'),
            type: 'input',
          },
        ];
      },
      columnList() {
        return [
          {
            prop: 'settleNo',
            label: this.$t('batchList.column.settleNo'),
          },
          {
            prop: 'settleDesc',
            label: this.$t('batchList.column.settleDesc'),
          },
        ];
      },
    },
    methods: {
      open(val) {
        this.defaultVisible = true;
        this.extraData = val;
        console.log(this.extraData);
      },
      close() {
        this.defaultVisible = false;
        this.extraData = {};
        // ================= 清空选中 =================
        this.$refs.selectTableDialog.$refs.siruiTable.clearSelectRecord();
        // ============================================
      },
      async confirm(val) {
        console.log(val);
        if (!val[0]) {
          return this.$message({ showClose: true, message: '请选择一条结算批次', type: 'error' });
        }
        this.$emit('updateSettle', val);
      },
    },
  };
</script>
